import { makeStyles } from "@material-ui/core"

import { colors } from "@/styles/colors"
import ColorUtil from "@/utils/ColorUtil"

const FAB_SIZE_IN_REM = "3.25rem"
const FAB_ELEVATION_IN_REM = "0.5rem"

const useStyles = makeStyles(theme => ({
	tabBar: {
		position: "fixed",
		bottom: 0,
		left: 0,
		right: 0,
		zIndex: 900,
		backgroundColor: colors.gray[0],
		borderTop: `1px solid ${colors.gray[200]}`,
		padding: "0.375rem 0.25rem 0.875rem"
	},
	tabItem: {
		cursor: "pointer",
		backgroundColor: "transparent",
		border: "none",
		padding: 0
	},
	tabIconInactive: {
		color: colors.gray[500]
	},
	tabIconActive: {
		color: colors.purple[500]
	},
	tabLabel: {
		fontSize: theme.typography.pxToRem(11),
		fontWeight: 600,
		lineHeight: 1
	},
	tabLabelInactive: {
		color: colors.gray[500]
	},
	tabLabelActive: {
		color: colors.purple[500]
	},
	fabContainer: {},
	newChatFabButton: {
		width: FAB_SIZE_IN_REM,
		height: FAB_SIZE_IN_REM,
		borderRadius: "50%",
		backgroundColor: colors.purple[500],
		color: colors.gray[0],
		transform: `translateY(-${FAB_ELEVATION_IN_REM})`,
		boxShadow: `0 ${FAB_ELEVATION_IN_REM} 1.25rem ${ColorUtil.hexToRgba(colors.purple[500], 0.36)}`,
		cursor: "pointer",
		border: "none",
		padding: 0,
		"&:hover": {
			backgroundColor: colors.purple[500]
		}
	}
}))

export default useStyles
